import { BROADCAST_SET_DIRECTOR_REQUEST_MESSAGE } from 'actions/Types';

const initialState = {
  canScreenShare: null
};

function directorRequestMessages(state = initialState, action) {
  if (action.type === `${BROADCAST_SET_DIRECTOR_REQUEST_MESSAGE}`) {
    const {
      payload: { key, value }
    } = action;
    return { ...state, [key]: value };
  }
  return state;
}

export default directorRequestMessages;
